import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AppDispatch, RootState } from '~/store';
import { client, gql } from '~/apollo-client';

const DELETE_COMMENT_IN_UPDATE = gql`
  mutation deleteCommentInUpdate($input: DeleteCommentInput!) {
    deleteCommentInUpdate(input: $input) {
      success
    }
  }
`;

export const deleteCommentInUpdate = createAsyncThunk<
  unknown,
  { postId: string; commentId: string },
  { state: RootState; dispatch: AppDispatch }
>('posts/deleteCommentInUpdate', async ({ postId, commentId }) => {
  const response = await client.mutate<
    {
      deleteCommentInUpdate: {
        success: boolean;
      };
    },
    { input: { postId: string; commentId } }
  >({
    mutation: DELETE_COMMENT_IN_UPDATE,
    variables: { input: { postId, commentId } },
  });

  return response.data;
});
